import { render, staticRenderFns } from "./PublicViewPost.vue?vue&type=template&id=6c7e689e&"
import script from "./PublicViewPost.vue?vue&type=script&lang=ts&"
export * from "./PublicViewPost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports